import React, {useEffect} from 'react';
import styles from "./VehicleSearch.module.scss";
import { Card } from "react-bootstrap";
import { translateService } from "../../services/TranslateService";
import Translate from 'react-translate-component';
import { useContext } from "react";
import { DataContext } from "../../contexts/dataContext";
import moment from "moment";
import useFilter from "./Filter";

function cx(...classes: string[]){
  let s = '';
  for (const a of classes)
    s += ` ${a}`
  return s;
}

export default function NoResults() {
  const { resetFilters } = useFilter()
  const { searchParameters, changeSearchParameters, filteredParams } = useContext(DataContext);
  const [ loading, setLoading ]  = React.useState<boolean>(true);
  let startDate = ''
  let endDate= ''
  let locationName;

  if (searchParameters) {
    if (searchParameters.startDate) {
      startDate = moment(searchParameters.startDate).format("DD.MM.YYYY")
    }
    if (searchParameters.endDate) {
      endDate = moment(searchParameters.endDate).format("DD.MM.YYYY")
    }

    if(searchParameters.location){
      if (typeof searchParameters.location === 'object') {
        // if object, new search was done after app startup (i.e., not using url params)
        locationName = searchParameters.location.address_components[0]?.long_name;
      } else {
        locationName = searchParameters.location;
      }
    }
  }

  React.useEffect(() => {
    // allows for 'loading' spinner to display when "No Results" is returned when actual results are processing in background
    setTimeout(() => { setLoading(false)}, 1000);
  }, [])

  return <>
      {loading ?
          <div className={styles.resultsLoaderDiv}>
            <span className={styles.resultsLoader}>  </span>
          </div>
          : searchParameters && Object.keys(searchParameters).length > 0 &&
          <Card className={`card-body my-4`}>
          <button className="btn btn-secondary btn-outline-secondary w-100" onClick={()=>{
              if(filteredParams.types || filteredParams.fuelType || filteredParams.transmission || filteredParams.selectedTag || filteredParams.tyreTypes || filteredParams.model){
                resetFilters()
              } else {
                // if no filters are set, resetFilters() will not be called, so we need to manually reset searchParameters
                changeSearchParameters((s: any) => ({...s, fuelType: undefined, vehicleType: undefined,
                  crossBorderArea: undefined, transmission: undefined, features: undefined}))
                }
              }}>
            {translateService.translate('vehicleSearch.resetSearchFilters')} </button>
          <h3 className={styles.emptyResultsH3Bold}>{ translateService.translate('vehicleSearch.noResults')}</h3>
          <div className={cx(styles.grayBackground, styles.r24Padding10, styles.blueBorderAround)}>
            <strong> { translateService.translate('vehicleSearch.rentalLocation')} </strong>
            <p> {locationName} </p>
            <div className={cx(styles.r24FullWidth, styles.grayLine, styles.r24TopBottomMargin5)}></div>
            <strong>{ translateService.translate('vehicleSearch.rentalTime')}</strong>:
            <p>{startDate} @ {searchParameters.startTime} - {endDate} @ {searchParameters.endTime}</p>
            <div className={cx(styles.r24FullWidth, styles.grayLine, styles.r24TopBottomMargin5)}></div>
                <div>
                  <strong>{translateService.translate('vehicleSearch.carModels')}</strong>:
                    { filteredParams.model && filteredParams.model !== 0 ?
                        <div><Translate content='vehicleSearch.noModelBasedResults'/></div>
                        :
                        <div>{filteredParams.types && filteredParams.types.length !== 0 ? filteredParams.types!.map((v: string) => {if(v) {return <div key={v}>- {translateService.translate('vehicleSearch.'+v) }</div>}
                        else return null}): <Translate with={{ type: translateService.translate('vehicleSearch.carModels')}} content='vehicleSearch.youHaveNotFiltered'/>}</div>
                    }
                </div>
            <hr></hr>
            <strong>{translateService.translate('vehicleSearch.fuelType')}</strong>:
            <div>
              {filteredParams.fuelType && !filteredParams.fuelType.includes('all') ? translateService.translate('vehicleSearch.'+filteredParams.fuelType.toLowerCase()) : <Translate with={{ type: translateService.translate('vehicleSearch.fuelType') }} content='vehicleSearch.youHaveNotFiltered' />}
            </div>

                <div>
                  <hr></hr>
                  <strong>{translateService.translate('vehicleSearch.crossBorderTravel')}</strong>:
                  <div> {filteredParams.selectedTag && !filteredParams.selectedTag.includes('all') ? translateService.translate('vehicleSearch.'+filteredParams.selectedTag?.toLowerCase()): <Translate with={{ type: translateService.translate('vehicleSearch.crossBorderTravel')}} content='vehicleSearch.youHaveNotFiltered' />} </div>
                </div>

                  <div>
                    <hr></hr>
                    <strong> {translateService.translate('vehicleSearch.transmission')}</strong>:
                    <div> {filteredParams.transmission && !filteredParams.transmission.includes('all') ? translateService.translate('vehicleSearch.'+filteredParams.transmission.toLowerCase()) :  <Translate with={{ type: translateService.translate('vehicleSearch.transmission')}} content='vehicleSearch.youHaveNotFiltered' />} </div>
                  </div>

                <div>
                  <hr></hr>
                  <strong> { translateService.translate('vehicleSearch.equipment')}</strong>:
                 <div>{filteredParams.tyreTypes && filteredParams.tyreTypes.length > 0 ? filteredParams.tyreTypes.map((v: string) => {if(v) {return <div key={v}> - {translateService.translate('vehicleSearch.'+v) }</div>} else return null }) : <Translate with={{ type: translateService.translate('vehicleSearch.equipment')}} content='vehicleSearch.youHaveNotFiltered' />}</div>
                </div>
          </div>
          <h3 className={styles.emptyResultsH3Bold}>{ translateService.translate('vehicleSearch.noAvailableVehicles')}</h3>
          <h3 className={styles.emptyResultsH3}>{ translateService.translate('vehicleSearch.tryNewParameters')}</h3>
        </Card>}
    </>
  }